// src/composables/useIsDesktop.ts
import { ref, onMounted, onUnmounted } from 'vue'

export function useIsDesktop(query = '(min-width: 920px)') {
  const mq = window.matchMedia(query)
  const isDesktop = ref(mq.matches)

  const onChange = (e: MediaQueryListEvent) => (isDesktop.value = e.matches)

  onMounted(() => mq.addEventListener('change', onChange))
  onUnmounted(() => mq.removeEventListener('change', onChange))

  return { isDesktop }
}
